import { cn } from "@/lib/utils";
import { SnapshotEventMail } from "@/modules/snapshots/businessReports.types";

interface Props {
  note: SnapshotEventMail;
  isSelected: boolean;
  sanitizedMessage: string;
  onSelect: (note: SnapshotEventMail) => void;
}

export const NoteListItem = ({ note, isSelected, sanitizedMessage, onSelect }: Props) => (
  <button
    type="button"
    onClick={() => onSelect(note)}
    className={cn("rounded-md border p-3 text-left transition-all", {
      "border-blue-500 bg-blue-50": isSelected,
      "border-transparent bg-transparent hover:bg-gray-100": !isSelected,
    })}
  >
    <div className="mb-1 flex items-center justify-between">
      <span className="text-sm font-medium text-gray-700">{note.title}</span>
      {note.is_default && (
        <span className="rounded bg-green-100 px-2 py-0.5 text-[10px] font-medium text-green-700">Default</span>
      )}
    </div>
    <p className="truncate text-xs text-gray-500" dangerouslySetInnerHTML={{ __html: sanitizedMessage }} />
  </button>
);
